<template>
  <div class="item-search">
    <b-row>
      <b-col cols="11">
        <v-select
          label="itemno"
          key="itemno"
          ref="ItemSearchSelect"
          placeholder="Buscar productos..."
          v-model="selected"
          :filterable="false"
          :options="options"
          @search="onSearch"
          @input="checkProductParameters()"
        >
          <template slot="no-options"> Buscar productos </template>
          <template slot="option" slot-scope="option">
            <div>
              {{ option.itemno }}
              [{{ option.variant }}]
              {{ option.description }}
            </div>
          </template>
          <template slot="selected-option" scope="option">
            <div>
              {{ option.itemno }}
              {{ option.variant }}
              {{ option.description }}
            </div>
          </template>
        </v-select>
      </b-col>
      <b-col cols="1" md="auto">
        <font-awesome-icon
          v-if="searchmode == 'b'"
          @click="toggleSearchMode('m')"
          icon="barcode"
          :style="{ color: 'black' }"
        />
        <font-awesome-icon
          v-if="searchmode == 'm'"
          @click="toggleSearchMode('b')"
          icon="keyboard"
          :style="{ color: 'black' }"
        />
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
    <!-- Botón generar vale. -->
    <b-card
      v-if="
        this.$store.state.curDocType == 1 &&
        this.$store.getters.OrderLines == 0 &&
        this.$store.state.curOrder == ''
      "
      style="max-width: 10rem; max-height: 10rem"
      bg-variant="success"
      text-variant="white"
      @click="createVoucher"
    >
      <b-card-text> Generar Vale </b-card-text>
    </b-card>
    &nbsp;&nbsp;
     <!-- Botón consultar/imprimir vale. -->
    <b-card
      v-if="
        this.$store.state.curDocType == 1 &&
        this.$store.getters.OrderLines == 0 &&
        this.$store.state.curOrder == ''
      "
      style="max-width: 10rem; max-height: 10rem"
      bg-variant="success"
      text-variant="white"
      @click="searchVoucher"
    >
      <b-card-text> Consultar Vale </b-card-text>
    </b-card>
    </b-row>

    <!-- Modal Component para solicitar un número de vale. -->
    <b-modal
      no-close-on-backdrop
      hide-footer
      ref="VoucherAmtModalRef"
      id="voucheramtmodal"
      title="Importe vale"
    >
      <b-list-group>        
        <b-form-input
          id="voucherAmount"
          type="number"
          v-model="voucherAmount"
          required
          placeholder="Importe"
          ref="VoucherAmtInput"
        ></b-form-input>
      </b-list-group>
      <b-list-group>
        <b-btn class="mt-3" variant="outline-success" @click="SetVoucherAmt()"
          >Procesar vale</b-btn
        >
        <b-btn class="mt-3" variant="outline-danger" @click="cancelVoucher()"
          >Cancelar</b-btn
        >
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import mixin from "@/components/mixin.js";
var axios = require("axios");
import _ from "lodash";
export default {
  name: "ItemSearch",
  data() {
    return {
      selected: null,
      options: [],
      inputtimeout: 0,
      voucherAmount: null,
      searchmode: "b",
    };
  },
  mounted: function () {
    // `this` points to the vm instance
    this.focusSearchUnsubscriber = this.$store.subscribe(
      (setFocusSearch, state) => {
        if (
          setFocusSearch.type == "setFocusSearch" &&
          setFocusSearch.payload == true
        ) {
          this.$refs.ItemSearchSelect.$refs.search.focus();
          this.$store.commit("setFocusSearch", false);
        }
      }
    );
  },
  beforeDestroy() {
    this.focusSearchUnsubscriber(); // call the unsubscribe function
  },
  methods: {
    onSearch(search, loading) {
      if (search.length > 3) {
        this.debouncedSearch(search, loading);
      }
    },
    debouncedSearch: _.debounce(function (search, loading) {
      this.search(search, loading);
    }, 300),
    search(search, loading) {
      //console.log(_.random(20))
      var searchApiURL = "";
      if (this.searchmode == "m") {
        searchApiURL = this.ApiBaseUrl + "ItemSearch";
      } else {
        searchApiURL = this.ApiBaseUrl + "ItemSearch/Barcode";
      }
      this.axios
        .post(searchApiURL, JSON.stringify(search), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.options = response.data;
          loading(false);
        });
    },
    checkProductParameters() {
      let selected = this.selected;

      if (selected != null && selected != undefined)
        if (selected.itemno != null && selected.itemno != undefined)
          if (selected.m3item === 0) {
            this.addProduct(selected);
          } else {
            let itemprops = {
              itemno: selected.itemno,
              description: selected.description,
              length: 1,
              height: 1,
              width: 1,
              qty: 1,
            };
            this.$store.commit("setitemproperties", itemprops);
            this.$refs.ItemSearchSelect.clearSelection();
            this.selected = null;
          }
    },
    addProduct(selected) {
      if (selected != null) {
        var req = {
          custId: this.$store.state.customer.id,
          itemno: selected.itemno,
          qty: 1,
          location: localStorage.getItem("defaultlocation"),
          unitprice: 0,
          linedisc: 0,
          usercardid: this.$store.state.UserCardId.cardNo,
          PosId: this.$store.state.PosId,
          variant: selected.variant
        };
        axios
          .post(
            this.ApiBaseUrl + "Sales/GetSalesLinePrice",
            JSON.stringify(req),
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            var data = JSON.parse(response.data.body.res);
            this.$set(selected, "unitprice", data.unitprice.replace(/\,/g, ""));
            this.$set(selected, "qty", 1);
            this.$set(selected, "linedisc", data.linedisc.replace(/\,/g, ""));
            this.$set(
              selected,
              "lineamount",
              data.lineamount.replace(/\,/g, "")
            );
            this.$set(selected, "vat", data.vat.replace(/\,/g, ""));
            this.$set(selected, "linetotal", data.linetotal.replace(/\,/g, ""));
            this.$set(
              selected,
              "location",
              localStorage.getItem("defaultlocation")
            );
            this.$set(selected, "availqty", data.availqty.replace(/\,/g, ""));
            this.$set(selected, "dtoManual", 0);
            this.$store.commit("addItem", selected);
            this.$store.commit("setglobaldiscpct", data.globaldiscpct);
          });
        this.$refs.ItemSearchSelect.clearSelection();
        this.selected = null;
        this.options = [];
        this.searchmode = "b";
      }
    },
    delProduct(item) {
      this.$store.commit("delItem", item);
    },
    searchVoucher(){      
      this.$store.commit("setVoucherModal", 1);      
    },
    createVoucher() {
      this.$refs.VoucherAmtModalRef.show();
      this.$nextTick(function () {
        this.$refs.VoucherAmtInput.focus();
      });
    },
    cancelVoucher() {
      this.$refs.VoucherAmtModalRef.hide();
    },
    SetVoucherAmt() {
      this.$refs.VoucherAmtModalRef.hide();
      this.$store.commit("setVale", 1);
      this.$store.commit("resetCart");
      this.$store.commit("setcurOrder", "VALE");
      //this.$store.commit("setcurOrder", selected.docNo);
      //this.$store.commit("setpaymentDocType", selected.docType);
      //this.$store.commit("setprintdoc", selected.docNo);
      this.$router.push("payment");
      var voucherItem = {
        itemno: "VALE",
        linetotal: this.voucherAmount,
      };

      this.$store.commit("addItem", voucherItem);
    },
    toggleSearchMode(mode) {
      this.searchmode = mode;
    },
  },
  created: function () {
    if (this.$store.state.vale == 1) {
      this.$store.commit("setVale", 0);
      this.$store.commit("resetCart");
      this.$store.commit("setcurOrder", "");
    }
  },
};
</script>
